export default {
  animation: 'fill',
  arrow: false,
  autoUpdate: false,
  flip: null,
  hideDelay: 0,
  hideDuration: 300,
  hideOn: 'mouseleave blur escapekey',
  interactive: false,
  isOffset: false,
  isShown: false,
  lazyRender: false,
  middleware: null,
  placement: 'top',
  floatingElementContainer: '.ember-application',
  floatingUiOptions: null,
  renderInPlace: false,
  showDelay: 0,
  showDuration: 300,
  showOn: 'mouseenter focus',
  style: null,
  tooltipClass: 'ember-attacher-floating ember-attacher-tooltip',
  useCapture: false,
  overflowPadding: 5
};